import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { coursePackagesData } from '../data/courseData';
import './ResourcePage.css';

function ResourcePage() {
    const { courseSlug } = useParams();
    const course = coursePackagesData.find(c => c.slug === courseSlug);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [courseSlug]);

    if (!course) {
        return (
            <div className="page-container">
                <h1>Resource Not Found</h1>
                <p>The resource you are looking for does not exist.</p>
                <Link to="/" className="hero-cta-button" style={{ textDecoration: 'none' }}>Back to Home</Link>
            </div>
        );
    }

    return (
        <div className="resource-page-container">
            <h1 className="resource-page-title">{course.name}</h1>
            <p className="resource-page-blurb">{course.resources.blurb}</p>

            <h2 className="resource-page-section-title">Helpful Videos</h2>
            <div className="resource-page-video-grid">
                {course.resources.videos.map((videoUrl, index) => (
                    <div key={index} className="resource-page-video-card">
                        <iframe
                            className="resource-page-video-iframe"
                            width="560"
                            height="315"
                            src={videoUrl}
                            title={`YouTube video player ${index + 1} for ${course.name}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ResourcePage;
